export enum AchievementType {
  medal = 'MEDAL',
  personalBest = 'PERSONAL_RECORD',
  streak = 'STREAK',
  totals = 'TOTALS',
  trophy = 'TROPHY',
}

export function achievementTypeFromString(value: string): AchievementType {
  const found = Object.values(AchievementType).find((v) => v === value);
  if (!found) throw new Error(`Unknown AchievementType: ${value}`);
  return found;
}

export interface Prerequisite {
  type: string;
  unit?: string | null;
  minValue?: number | null;
  exactValue?: number | null;
  maxValue?: number | null;
}

export function prerequisiteFromJson(json: Record<string, unknown>): Prerequisite {
  return {
    type: json['type'] as string,
    unit: (json['unit'] as string | null) ?? null,
    minValue: (json['minValue'] as number | null) ?? null,
    exactValue: (json['exactValue'] as number | null) ?? null,
    maxValue: (json['maxValue'] as number | null) ?? null,
  };
}

export interface Achievement {
  id: string;
  type: AchievementType;
  isEnabled: boolean;
  isRepeatable: boolean;
  title: string;
  subtitle: string;
  position: number;
  prerequisiteText: string;
  prerequisite?: Prerequisite | null;
}

export function achievementFromJson(json: Record<string, unknown>): Achievement {
  return {
    id: json['id'] as string,
    type: achievementTypeFromString(json['type'] as string),
    isEnabled: json['isEnabled'] as boolean,
    isRepeatable: json['isRepeatable'] as boolean,
    title: json['title'] as string,
    subtitle: json['subtitle'] as string,
    position: (json['position'] as number | null) ?? 0,
    prerequisiteText: json['prerequisiteText'] as string,
    prerequisite:
      json['prerequisite'] != null
        ? prerequisiteFromJson(json['prerequisite'] as Record<string, unknown>)
        : null,
  };
}
